import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { TOURNAMENT_TERMS, type TournamentTermKey } from "@bw/shared/tournaments";

import type { EventCatalogItem } from "../hooks/useTournamentEventCatalog";
import { PlayerTermHelp } from "./PlayerTermHelp";

const TERM_KEYS = new Set<string>(TOURNAMENT_TERMS.map((term) => term.key));

/** "Knockout + consolation ⓘ · At least 2 matches" (#2691, F25). Server text
 * only; nothing renders when the event has no format yet. */
export function EventFormatLine({ item }: { item: EventCatalogItem }) {
  if (!item.format_label) return null;
  const term = item.format_term && TERM_KEYS.has(item.format_term) ? (item.format_term as TournamentTermKey) : null;
  return (
    <Stack data-testid="event-format-line" direction="row" sx={{ alignItems: "center", gap: 0.75, mt: 0.5, flexWrap: "wrap" }}>
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.25 }}>
        <Typography sx={{ fontSize: "0.875rem" }}>{item.format_label}</Typography>
        {term ? <PlayerTermHelp term={term} /> : null}
      </Stack>
      {item.guarantee_label ? (
        <Box
          component="span"
          sx={(theme) => ({
            px: 1,
            py: 0.25,
            borderRadius: 999,
            fontSize: "0.8125rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
            color: "primary.main",
            bgcolor: alpha(theme.palette.primary.main, 0.14),
          })}
        >
          {item.guarantee_label}
        </Box>
      ) : null}
    </Stack>
  );
}
